// This file is auto-generated. Do not edit!

export default [
  {
    symbol: "USDC",
    token: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
    fToken: "0x9Fb7b4477576Fe5B32be4C1843aFB1e55F251B33",
  },
  {
    symbol: "WETH",
    token: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
    fToken: "0x90551c1795392094FE6D29B758EcCD233cFAa260",
  },
  {
    symbol: "USDT",
    token: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
    fToken: "0x5C20B550819128074FD538Edf79791733ccEdd18",
  },
  {
    symbol: "wstETH",
    token: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
    fToken: "0x2411802D8BEA09be0aF8fD8D08314a63e706b29C",
  },
  {
    symbol: "GHO",
    token: "0x40D16FC0246aD3160Ccc09B8D0D3A2cD28aE6C2f",
    fToken: "0x6A29A46E21C730DcA1d8b23d637c101cec605C5B",
  },
  {
    symbol: "sUSDS",
    token: "0xa3931d71877C0E7a3148CB7Eb4463524FEc27fbD",
    fToken: "0x2BBE31d63E6813E3AC858C04dae43FB2a72B0D11",
  },
  {
    symbol: "USDtb",
    token: "0xC139190F447e929f090Edeb554D95AbB8b18aC1C",
    fToken: "0x15e8c742614b5D8Db4083A41Df1A14F5D2bFB400",
  },
] as const
